import React from "react";
import { Box, Flex, Grid, Icon, Skeleton, Text, } from "@chakra-ui/react";
import BeneficiaryAssestmentTable from "./BeneficiaryAssessmentTable";
import { useBeneficiaries } from "hooks/beneficiaries";

const BeneficiaryFirstAssessment = () => {
    const { beneficiary } = useBeneficiaries();
    const firstAssessment = beneficiary?.firstReception;

    return (
        <Flex width="100%" height="100%" direction="column">
            <Grid
                templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
                templateRows={{ sm: "repeat(1, 1fr)", md: "repeat(1, 1fr)" }}
                gap="20px"
                width="100%"
            >
                {
                    !beneficiary ?
                        <Box width="100%">
                            <Flex width="100%" fontSize="15px">
                                <Icon icon="note" margin="25" size="xl" />
                                <Grid
                                    templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
                                    templateRows={{ sm: "repeat(1, 1fr)", md: "repeat(1, 1fr)" }}
                                    gap="6px"
                                    fontSize="20px"
                                    width="100%"
                                >
                                    <Skeleton isLoaded={beneficiary} height="27px" />
                                    <Skeleton isLoaded={beneficiary} height="30px" />
                                </Grid>
                            </Flex>
                        </Box>
                        :
                        !firstAssessment ?
                            <Text fontSize="lg" fontWeight="bold">
                                Formulário ainda não foi respondido
                            </Text>
                            :
                            <BeneficiaryAssestmentTable assessment={firstAssessment} />
                }
            </Grid>
        </Flex>
    )
}

export default BeneficiaryFirstAssessment
